// sessions/utils/energy.ts
export const formatEnergy = (raw = "") => {
  if (!raw) return "-";
  const kwh = parseFloat(raw.replace(/KWh/i, "").trim());
  return `${(kwh).toFixed(2)} kWh`;
};
